import { render, staticRenderFns } from "./PostcodeProductMixGeneral.vue?vue&type=template&id=da1d4cf0&scoped=true&"
import script from "./PostcodeProductMixGeneral.vue?vue&type=script&lang=ts&"
export * from "./PostcodeProductMixGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./PostcodeProductMixGeneral.vue?vue&type=style&index=0&id=da1d4cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d4cf0",
  null
  
)

export default component.exports